import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Icon } from "../../../components/Icons";

const Tab = ({
	id,
	selectedKey,
	onClick,
	onKeyDown,
	onKeyUp,
	label,
	subLabel,
	newLabel,
	icon,
	activeClassName,
	className,
	focusedKey,
	isFocused,
	tabIconClassName,
}) => {
	const ref = useRef(null);
	const isSelected = id === selectedKey;
	useEffect(() => {
		if (isFocused && id === focusedKey && ref.current !== null) {
			ref.current.focus();
		}
	}, [isFocused, focusedKey, id]);

	return (
		<a
			ref={ref}
			className={`${className} ${isSelected ? activeClassName : ""}`}
			href={`#${id}`}
			role="tab"
			data-testid={id}
			tabIndex={isSelected ? 0 : -1}
			onClick={e => onClick(e, id)}
			onKeyDown={e => onKeyDown(e)}
			onKeyUpCapture={e => onKeyUp(e)}>
			{icon && <Icon name={icon} className={tabIconClassName} />}
			<span>
				{label}
				{newLabel && <strong>{newLabel}</strong>}
			</span>
			{subLabel && <span>{subLabel}</span>}
		</a>
	);
};
Tab.displayName = "Tab";

Tab.propTypes = {
	selectedKey: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	onKeyDown: PropTypes.func.isRequired,
	onKeyUp: PropTypes.func.isRequired,
	activeClassName: PropTypes.string.isRequired,
	className: PropTypes.string.isRequired,
	label: PropTypes.node.isRequired,
	id: PropTypes.string.isRequired,
	isFocused: PropTypes.bool.isRequired,
	subLabel: PropTypes.string,
	newLabel: PropTypes.string,
	icon: PropTypes.string,
	focusedKey: PropTypes.string,
	tabIconClassName: PropTypes.string,
};

Tab.defaultProps = {
	selectedKey: undefined,
	subLabel: null,
	newLabel: null,
	icon: null,
	focusedKey: null,
	tabIconClassName: null,
};

export default Tab;
export { Tab };
